<nz-card [nzTitle]="operationNoteParticipantForm">
  <app-operation-note-participant-table></app-operation-note-participant-table>
</nz-card>

<ng-template #operationNoteParticipantForm>
  <app-operation-note-participant-form></app-operation-note-participant-form>
</ng-template>
